<ion-content>
  <app-global-page-header
    [title]="'functions.filtration.usagemode.title' | translate"
  >
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-4">
    <p
      class="my-2 mb-4 color-medium"
      [innerHTML]="'P0003606.installation.regulation.esp' | translate | nl2Br"
    ></p>

    <div>
      <table
        class="table table-bordered"
        style="width: 100%; border-width: 2px !important"
      >
        <tr>
          <th class="fw-normal p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp11' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp12' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp13' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp14' | translate }}
          </th>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp21' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp22' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp23' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp24' | translate }}
          </td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp31' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp32' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp33' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp34' | translate }}
          </td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp41' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp42' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp43' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp44' | translate }}
          </td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp51' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp52' | translate }}
          </td>
          <td class="p-1 color-medium">
            {{ '-' }}
          </td>
          <td class="p-1 color-medium">
            {{ 'P0003606.installation.regulation.esp54' | translate }}
          </td>
        </tr>
      </table>
    </div>

    <p
      class="my-2 mb-4 color-danger"
      [innerHTML]="'P0003606.installation.correcteur.esp' | translate | nl2Br"
    ></p>

    <p
      class="my-2 mb-4 color-medium"
      [innerHTML]="'P0003606.installation.correcteur.esp2' | translate | nl2Br"
    ></p>
  </div>
</ion-content>
